module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 020.81e405db.jpg";